import { matchRoute } from "./routes";

/**
 * Minimal path-based router. There is no client-side navigation: every route
 * is prerendered to its own HTML file and hydrates itself, so navigation
 * happens via normal <a> links (full document loads). App simply renders the
 * element matching the current path — supplied explicitly during SSR, read
 * from `window.location` during hydration (they always agree, because each
 * file lives at its own path).
 */
export default function App({ path }: { path?: string }): JSX.Element {
  const pathname =
    path ?? (typeof window !== "undefined" ? window.location.pathname : "/");
  return matchRoute(pathname).element;
}
